import { Environment } from '@sankarah/commo-shared-environment';
import {
  PublicAppUrl,
  SupabaseKey,
  SupabaseUrl,
} from '@sankarah/shared-environment';

/** クラウドの development 環境向け（ビルドは `nx build commo --configuration=development`） */
export const environment: Environment = {
  production: false,
  serviceWorker: true,
  /** Secrets の VAPID_PUBLIC_KEY と一致させる。空だと Notifications トグル無効（docs/deploy.md） */
  vapidPublicKey:
    'BJ2_2m3BxVqeaY0cZz3ChCCtzCS-kljaFXjadGuoSRaCNsdwLmhvNrpgWA-pDocHnDXj--n7KVBrxJJBAwaJ99Q',
  /** Client Keys の DSN。空だとエラー監視オフ（docs/deploy.md） */
  sentryDsn:
    'https://fa142324449beff790ef2209979aba1f@o4512127497535488.ingest.us.sentry.io/4512127530696704',
  supabaseUrl: SupabaseUrl.Development,
  supabaseKey: SupabaseKey.Development,
  publicAppUrl: PublicAppUrl.Development,
};
